<template>
    <card>
        <card-header>Recent Reviews</card-header>
        <card-body class="pt-0" v-if="loading">
            <card-spinner style="min-height: 300px;"></card-spinner>
        </card-body>
        <card-body class="p-0" v-if="!loading">

            <review-widget-grid
                v-for="review of reviews"
                :key="review.id"
                :review="review"
                :type="type"
            />

            <div class="no-feedback text-center py-3" v-if="!reviews.length">
                <em>(No data found)</em>
            </div>
        </card-body>
    </card>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            type: { default: 'public' },
        },

        data: () => ({
            loading: true,
            reviews: [],
        }),

        created() {
            this.fetchRecentReviews().then(() => this.loading = false);
        },

        computed: {
            ...mapState(['filter']),
        },

        watch: {
            filter() { this.fetchRecentReviews(); },
        },

        methods: {
            fetchRecentReviews() {
                const params = {
                    ...this.filter,
                    type: this.type,
                    sortBy: 'review_date|desc',
                };
                return this.$http.get(this.$laroute.route('api.reviews.recent'), { params })
                    .then(({data}) => this.reviews = data.data)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .no-feedback {
        opacity: 0.5;
    }
</style>
